export abstract class SessionTimeoutHandlerService {
  abstract dismiss(): void;
}
